import { LoginStore } from '@modules/authentication/pages/login/login.store';
import { BreadcrumbService } from '@policoders/ds';
import { useService, useStore } from '@policoders/di';
import { useEffect, useState } from 'react';

import { UserProfile } from './user-profile.model';
import { UserProfileStore } from './user-profile.store';

export const useUserProfile = () => {
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState<UserProfile>(new UserProfile());
  const loginState = useStore<LoginStore>('LoginStore').state;
  const store = useService<UserProfileStore>('UserProfileStore');
  const breadcrumb = useService<BreadcrumbService>('BreadcrumbService');

  useEffect(() => {
    breadcrumb.set([
      { label: 'Início', value: '/' },
      { label: 'Perfil', value: '' },
    ]);
  }, [breadcrumb]);

  useEffect(() => {
    if (!loading) return;
    loginState.user?.email &&
      store.load(loginState.user?.email).subscribe(value => {
        setState(value);
        setLoading(false);
      });
  }, [loading, loginState.user?.email, store]);

  useEffect(() => {
    store.updateCurrent(state);
  }, [state, store]);

  const handleChange = (e: any) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    store.save();
  };

  return { state, handleChange, handleSave };
};
